import { FC, useState } from 'react';
import { PageWrapper, TabList } from '@/components/ui';
import { InternalManualPayments, InternalSubscriptionsTable } from '@/features/dashboard/components/internal';

const PaymentsPage: FC = () => {
    const [activeTab, setActiveTab] = useState('payments');

    return (
        <PageWrapper
            title="Payments & Subscriptions"
            subtitle="Manage global transaction history, subscriptions, and manual settlements."
            tabs={
                <TabList
                    tabs={[
                        { id: 'payments', label: 'Payments' },
                        { id: 'subscriptions', label: 'Subscriptions' }
                    ]}
                    activeTab={activeTab}
                    onChange={setActiveTab}
                    variant="underline"
                    className="border-none" // Remove border if PageHeader adds one, usually distinct style
                />
            }
        >
            <div className="max-w-7xl mx-auto space-y-6">
                {activeTab === 'payments' ? (
                    <InternalManualPayments />
                ) : (
                    <InternalSubscriptionsTable />
                )}
            </div>
        </PageWrapper>
    );
};

export default PaymentsPage;
